import React from "react";

const ChevronRightArrow = ({ fill, width }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 6 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.43143 8.71475L5.35059 4.80176L4.47324 3.92579L0.554091 7.83879L1.43143 8.71475Z"
      fill={fill}
    />
    <path
      d="M0.557671 1.60547L4.47363 5.52148L5.35026 4.64485L1.4343 0.728829L0.557671 1.60547Z"
      fill={fill}
    />
  </svg>
);

ChevronRightArrow.defaultProps = {
  width: 8,
  fill: "black",
};

export default ChevronRightArrow;
